import { CityState, DataSource, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFactoringCompanySummaryQuickInfo extends Layout {
    citystateFC: CityState;
    labelListSubtitle: Label;
    labelListTitle: Label;
    panelFactoringCompanyInfo: Panel;
    panelFactoringCompanyList: Panel;
    sourceFactoringCompanySummary: DataSource;
    sourceSelectedFactoringCompany: DataSource;
    tableFactoringCompanies: Table;
    textboxCode: Textbox;
    textboxName: Textbox;
    textboxPhoneNumber: Textbox;
}
